import React, { useState } from "react";
import {
  CircularProgress,
  TextField,
} from "@material-ui/core";

const IntegrationsSection = ({
  integrationConnections,
  crmExportLogs,
  isIntegrationsLoading,
  isCrmExportLogsLoading,
  onSearchCrmExportLogs,
  entityId,
}) => {
  const [crmExportLogsSearchQuery, setCrmExportLogsSearchQuery] = useState("");
  const [expandedErrors, setExpandedErrors] = useState({});
  const [expandedLeadData, setExpandedLeadData] = useState({});

  const handleToggleErrorExpand = (logId) => {
    setExpandedErrors({
      ...expandedErrors,
      [logId]: !expandedErrors[logId],
    });
  };

  const handleToggleLeadDataExpand = (logId) => {
    setExpandedLeadData({
      ...expandedLeadData,
      [logId]: !expandedLeadData[logId],
    });
  };

  return (
    <div>
      <div
        style={{
          border: "1px solid #e0e0e0",
          borderRadius: "4px",
          padding: "0.75rem",
        }}
      >
        <div>
          <h4 style={{ marginTop: "1rem", marginBottom: "0.5rem" }}>
            Integrations
          </h4>

          {isIntegrationsLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "80px",
              }}
            >
              <CircularProgress size={24} />
            </div>
          ) : integrationConnections && integrationConnections.length > 0 ? (
            <div
              style={{
                backgroundColor: "#f9f9f9",
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
                padding: "0.75rem",
              }}
            >
              <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                {integrationConnections.map((connection, index) => (
                  <div
                    key={connection.id || index}
                    style={{
                      padding: "8px",
                      marginBottom: "8px",
                      borderBottom:
                        index < integrationConnections.length - 1
                          ? "1px solid #e0e0e0"
                          : "none",
                    }}
                  >
                    <p style={{ margin: "4px 0", fontSize: "14px" }}>
                      <strong>UID:</strong> {connection.uid}
                    </p>
                    {connection.memberId && (
                      <p style={{ margin: "4px 0", fontSize: "14px" }}>
                        <strong>Member ID:</strong> {connection.memberId}
                      </p>
                    )}
                    {connection.parentTeamId && (
                      <p style={{ margin: "4px 0", fontSize: "14px" }}>
                        <strong>Team ID:</strong> {connection.parentTeamId}
                      </p>
                    )}
                    <p style={{ margin: "4px 0", fontSize: "14px" }}>
                      <strong>Created At:</strong>{" "}
                      {connection.createdAt
                        ? new Date(connection.createdAt).toLocaleString()
                        : "N/A"}
                    </p>
                    <p style={{ margin: "4px 0", fontSize: "14px" }}>
                      <strong>Integration:</strong> {connection.integration}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <p style={{ textAlign: "center", color: "#666" }}>
              No integration connections available
            </p>
          )}
        </div>

        <div>
          <h4 style={{ marginTop: "1rem", marginBottom: "0.5rem" }}>CRM Export Logs</h4>
          <div
            style={{
              border: "1px solid #e0e0e0",
              borderRadius: "4px",
              padding: "0.75rem",
              backgroundColor: "#f9f9f9",
            }}
          >
            <div style={{ marginBottom: "1rem" }}>
              <form
                autoComplete="off"
                onSubmit={async (e) => {
                  e.preventDefault();
                  if (onSearchCrmExportLogs) {
                    await onSearchCrmExportLogs(entityId, crmExportLogsSearchQuery);
                  }
                }}
              >
                <div style={{ display: "flex", gap: "0.5rem" }}>
                  <TextField
                    autoComplete="off"
                    fullWidth
                    label="Integration type or lead email"
                    variant="outlined"
                    size="small"
                    value={crmExportLogsSearchQuery}
                    onChange={(e) => setCrmExportLogsSearchQuery(e.target.value)}
                    disabled={isCrmExportLogsLoading}
                  />
                  <button
                    type="submit"
                    style={{
                      background: "#2196f3",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      padding: "6px 16px",
                      cursor: "pointer",
                      fontSize: "14px",
                      minWidth: "80px",
                    }}
                    disabled={isCrmExportLogsLoading}
                  >
                    Search
                  </button>
                </div>
              </form>
            </div>

            {isCrmExportLogsLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "80px",
                }}
              >
                <CircularProgress size={24} />
              </div>
            ) : crmExportLogs && crmExportLogs.length > 0 ? (
              <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                {crmExportLogs.map((log, index) => (
                  <div
                    key={log.id || index}
                    style={{
                      padding: "8px",
                      margin: "4px 0",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "4px",
                    }}
                  >
                    <p style={{ margin: "2px 0", fontSize: "14px" }}>
                      <strong>ID:</strong> {log.id}
                    </p>
                    <p style={{ margin: "2px 0", fontSize: "14px" }}>
                      <strong>Lead:</strong> {log.leadEmail || "N/A"}
                    </p>
                    <p style={{ margin: "2px 0", fontSize: "14px" }}>
                      <strong>CRM:</strong> {log.integrationType || "N/A"}
                    </p>
                    <p style={{ margin: "2px 0", fontSize: "14px" }}>
                      <strong>Status:</strong>{" "}
                      {log.status || "N/A"}
                    </p>
                    {log.status !== 1 && log.errorMessage && (
                      <div
                        style={{ margin: "2px 0", fontSize: "14px", color: "#d32f2f" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                          }}
                        >
                          <strong style={{ marginRight: "8px" }}>Error:</strong>
                          <div style={{ flex: 1, wordBreak: "break-word" }}>
                            {expandedErrors[log.id]
                              ? log.errorMessage
                              : log.errorMessage.length > 100
                                ? `${log.errorMessage.slice(0, 50)}...`
                                : log.errorMessage}
                          </div>
                          {log.errorMessage.length > 100 && (
                            <button
                              onClick={() => handleToggleErrorExpand(log.id)}
                              style={{
                                background: "none",
                                border: "none",
                                color: "#1976d2",
                                cursor: "pointer",
                                fontSize: "12px",
                                padding: "0 0 0 8px",
                              }}
                            >
                              {expandedErrors[log.id] ? "Collapse" : "Expand"}
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                    {log.leadData && (
                      <div style={{ margin: "2px 0", fontSize: "14px" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{ display: "flex" }}>
                            <strong style={{ marginRight: "8px" }}>Lead Data:</strong>
                            <div>
                              <pre style={{ whiteSpace: "pre-wrap" }}>
                                {expandedLeadData[log.id]
                                  ? JSON.stringify(log.leadData, null, 2)
                                  : `${JSON.stringify(log.leadData).slice(0, 50)}...`}
                              </pre>
                            </div>
                          </div>
                          {JSON.stringify(log.leadData).length > 100 && (
                            <button
                              onClick={() => handleToggleLeadDataExpand(log.id)}
                              style={{
                                background: "none",
                                border: "none",
                                color: "#1976d2",
                                cursor: "pointer",
                                fontSize: "12px",
                                padding: "0 0 0 8px",
                              }}
                            >
                              {expandedLeadData[log.id] ? "Collapse" : "Expand"}
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                    <p style={{ margin: "2px 0", fontSize: "14px" }}>
                      <strong>Category:</strong> {log.isParagon ? "Paragon" : "Native"}
                    </p>
                    {log.memberId && (
                      <p style={{ margin: "2px 0", fontSize: "14px" }}>
                        <strong>Member ID:</strong> {log.memberId || "N/A"}
                      </p>
                    )}
                    <p style={{ margin: "2px 0", fontSize: "14px" }}>
                      <strong>Created:</strong>{" "}
                      {log.createdAt ? new Date(log.createdAt).toLocaleString() : "N/A"}
                    </p>
                    {log.metadata && (
                      <div style={{ margin: "4px 0", fontSize: "14px" }}>
                        <strong>Metadata:</strong>
                        <pre
                          style={{
                            whiteSpace: "pre-wrap",
                            backgroundColor: "#e0e0e0",
                            padding: "4px",
                            borderRadius: "4px",
                            fontSize: "12px",
                            maxHeight: "100px",
                            overflow: "auto",
                          }}
                        >
                          {typeof log.metadata === "string"
                            ? JSON.stringify(JSON.parse(log.metadata), null, 2)
                            : JSON.stringify(log.metadata, null, 2)}
                        </pre>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <p style={{ textAlign: "center", color: "#666" }}>
                No CRM export logs available
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntegrationsSection;
